export default __webpack_public_path__ + "static/media/s3_male.c1ae383c.wav";